import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import { AccessControl } from '../../../components';
import { default as PermissionContextProvider } from '../../../context/PermissionContext/PermissionContext';
import { useAtsAccess, AtsAccess } from '../../../hooks/useAtsAccess';
import { Loader } from '../../conversationWidget/components/Loader';
import ActiveConsultantsPage from '../ActiveConsultantsPage';
export const ActiveConsultantsRoutes = () => {
  const isViewActiveConsultantList = useAtsAccess(AtsAccess.ACTIVE_CONSULTANTS);
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PermissionContextProvider>
            <RouteWithTitle title="Active Consultants- Wisestep">
              {isViewActiveConsultantList == undefined ? (
                <Loader />
              ) : isViewActiveConsultantList ? (
                <ActiveConsultantsPage />
              ) : (
                <AccessControl />
              )}
            </RouteWithTitle>
          </PermissionContextProvider>
        }
      />
    </Routes>
  );
};
